import {SpFile, SpRemoteFile} from "../inputs/interfaces";

export type SpSpotTransferIndicatorAction =
    // Pause transfer
    'pause' |
    // Resume transfer
    'resume' |
    // Abort ongoing transfer
    'abort' |
    // Retry to transfer aborted / erroneous transfer
    'retry' |
    // Queue an aborted / erroneous spot
    'queue' |
    // Remove a finished transfer from list
    'remove' |
    // Navigate to a spot
    'browse';

export interface SpTransferringSpot {
    id: string;
    image: SpFile | SpRemoteFile;
    status: SpTransferStatus;
    // Translation string or string
    error?: string;
    progress: number;
    direction: 'uploading' | 'downloading' | 'both';
}

export const enum SpTransferStatus {
    NotStarted,
    Executing,
    Paused,
    PostProcessing,
    Aborted,
    Erroneous,
    Finished
}